module.exports = {"ContentEmail":{"label":"Email"},"ContentPage":{"label":"Page content"},"ContentSnippet":{"label":"Content snippets"}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/configurations/content/typeToName_en.json
// module id = repI
// module chunks = 53